<lite-youtube
  class="rounded rounded-tix my-3"
  [attr.videoid]="videoId"
></lite-youtube>
